import React from 'react'
import { Select, Input, DatePicker, } from 'antd'
import moment from 'moment'

function ProductionStageFilters(props) {
    const { RangePicker } = DatePicker
    const {
        stage, partner,
        loading,
        handleChangeSelect,
        handleChangeUpdated,
        updatedStart, updatedEnd,
        handleChangeStage,
        listPartner,
    } = props
    const dateFormat = "DD/MM/YYYY"
    const dateFilterValue = updatedStart && updatedEnd ? [moment(updatedStart, dateFormat), moment(updatedEnd, dateFormat)] : []


    const partnerOptions = listPartner.filter(i => i.name === "QUANG MINH" || i.name === "TOÀN CẦU" || i.name === "BINH MINH").map(i => ({
        label: i.name,
        value: i._id,
    }))

    return (
        <div className='ProductionStageFilters TableFilter d-xl-flex justify-content-between align-items-end'>
            <div className="Filter">
                <div className="d-flex flex-wrap justify-content-start">
                    <div className="FilterWrapper FilterOptions mr-2 mb-3">
                        <div className="CustomSelect d-flex align-items-stretch justify-content-end">
                            <Input
                                style={{ width: "400px" }}
                                mode='tags'
                                placeholder='Tìm kiếm: Công đoạn'
                                allowClear
                                disabled={loading}
                                onChange={(e) => handleChangeStage(e.target.value)}
                                value={stage || ''}
                            />
                        </div>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="Đối tác sản xuất"
                            allowClear
                            value={partner || []}
                            onChange={handleChangeSelect}
                            disabled={loading}
                            options={partnerOptions}
                        >
                            {/* <Option value='order'>Đơn</Option>
                            <Option value='package'>Thùng</Option> */}
                        </Select>
                    </div>

                    {/* <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="Trạng thái"
                            allowClear
                            value={status || []}
                            onChange={handleChangeStatus}
                            disabled={loading}
                        >
                            <Option value='open'>Open</Option>
                            <Option value='confirmed'>Confirmed</Option>
                        </Select>
                    </div> */}

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Input.Group compact className='d-flex align-items-center FilterRangeDate'>
                            <div className={`textFilter d-flex align-items-center ${loading ? 'disabled' : ''}`}>
                                <label className='mb-0'>Ngày cập nhật: </label>
                            </div>
                            <RangePicker
                                id='createdAt'
                                placeholder={['Bắt đầu', 'Kết thúc']}
                                ranges={{
                                    'Today': [moment().startOf('day'), moment().endOf('day')],
                                    'Last 7 Days': [moment().subtract(6, 'day').startOf('day'), moment().endOf('day')],
                                    'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
                                }}
                                format={dateFormat}
                                onChange={handleChangeUpdated}
                                popupStyle={{ maxWidth: '600px' }}
                                disabled={loading}
                                value={dateFilterValue}
                            />
                        </Input.Group>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductionStageFilters